/*
 * Использовать переменную Global только на клиенте!!!
 * */
export const Global = {
  store: { dispatch: () => {} },

  saveStore(store) {
    this.store = store;
  },
};
